import React from "react";
import { BotaoMenor } from "../../../StyledComponent";
import FacebookIcon from "../../../../assets/facebook_federation.png";
import InstagramIcon from "../../../../assets/instagram_social.png";
import YouTubeIcon from "../../../../assets/youtube_social.png";
import { Link } from "react-router-dom";
import Fade from "@material-ui/core/Fade";

import "./styles.scss";

const MsgSucesso = () => {
  return (
    <Fade in>
      <div className="centralized-column msgSucesso">
        <h1>Primeiro acesso:</h1>
        <p className="msgSucesso__msg">
          Seja bem-vindo(a) ao <strong>portal do cliente</strong>, sua conta foi
          validada com sucesso e agora pode <strong>fazer seu login</strong> e
          aproveitar todas as funcionalidades do nosso sistema.
        </p>
        <Link to="/" id="btnAccessPortal">
          <BotaoMenor className="msgSucesso__btn">ACESSAR O PORTAL</BotaoMenor>
        </Link>

        <div className="msgSucesso__msgSocialMedia centralized-column">
          <p className="msgSucesso__msgSocialMedia__msg">
            Não se esqueça de nos seguir na sua rede social favorita para{" "}
            <strong>obter atualizações importantes, dicas e mais!</strong>
          </p>
          <div className="msgSucesso__msgSocialMedia__socialMedia centralized-space-evenly">
            <img src={FacebookIcon} alt="Facebook" />
            <img src={InstagramIcon} alt="Instagram" />
            <img src={YouTubeIcon} alt="Facebook" />
          </div>
        </div>
      </div>
    </Fade>
  );
};

export default MsgSucesso;
